export const UPDATE_SELECTED_DATE_RANGE = 'UPDATE_SELECTED_DATE_RANGE';
export const SET_CURRENT_HISTORY_CHAT_ITEM = 'SET_CURRENT_HISTORY_CHAT_ITEM';
export const HISTORY_LOADING = 'HISTORY_LOADING';
export const HISTORY_RECEIVED = 'HISTORY_RECEIVED';
export const HISTORY_ERROR = 'HISTORY_ERROR';
export const MORE_HISTORY_RECEIVED = 'MORE_HISTORY_RECEIVED';
export const UPDATE_HISTORY_FILTER = 'UPDATE_HISTORY_FILTER';
export const REMOVE_HISTORY_FILTER_ITEM = 'REMOVE_HISTORY_FILTER_ITEM';
export const CLEAR_HISTORY_FILTER = 'CLEAR_HISTORY_FILTER';
export const CLEAR_CURRENT_HISTORY_CHAT_ITEM = 'CLEAR_CURRENT_HISTORY_CHAT_ITEM';
export const GET_CURRENT_HISTORY_LOADING = 'GET_CURRENT_HISTORY_LOADING';
export const GET_CURRENT_HISTORY_RECEIVED = 'GET_CURRENT_HISTORY_RECEIVED';
export const GET_CURRENT_HISTORY_FAILED = 'GET_CURRENT_HISTORY_FAILED';
export const UPDATE_CUSTOM_AGENT_NOTE_FORM_IN_HISTORY = 'UPDATE_CUSTOM_AGENT_NOTE_FORM_IN_HISTORY';
export const UPDATE_REVIEW_STATUS_IN_HISTORY = 'UPDATE_REVIEW_STATUS_IN_HISTORY';



// WEBPACK FOOTER //
// ./src/data/redux/history_details/actiontypes.js